var _rect, _path, _path2, _rect2, _g, _path3, _path4, _g2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFjd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2441_3821",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2441_3821)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#67BFE5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2441_3821",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2441_3821)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2441_3821",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9375,
    height: 13.4167,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2441_3821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.44055 12.4582L1.40638 14.123L13.0021 1.81011L14.5038 -0.663855L11.4594 -1.22029L6.7298 4.08571L2.92294 7.66071L-1.44055 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.05078 13.6247L0.3996 14.5908L13.9646 -0.893656H11.9281L-1.05078 13.6247Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3781 12.4582L11.5311 14.123L-0.0646162 1.81011L-1.56631 -0.663855L1.47808 -1.22029L6.2077 4.08571L10.0146 7.66071L14.3781 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2809 13.2956L12.8305 14.2617L7.05439 7.63201L5.3419 6.89129L-1.71083 -0.655139H0.325672L7.37444 6.71217L9.24675 7.60037L14.2809 13.2956Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-1_2441_3821",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 15,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -1,
    width: 15,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73887 0V-0.75H4.98887V0H5.73887ZM7.17637 0H7.92637V-0.75H7.17637V0ZM5.73887 5.75V6.5H6.48887V5.75H5.73887ZM0 5.75V5H-0.75V5.75H0ZM0 7.66667H-0.75V8.41667H0V7.66667ZM5.73887 7.66667H6.48887V6.91667H5.73887V7.66667ZM5.73887 13.4167H4.98887V14.1667H5.73887V13.4167ZM7.17637 13.4167V14.1667H7.92637V13.4167H7.17637ZM7.17637 7.66667V6.91667H6.42637V7.66667H7.17637ZM12.9375 7.66667V8.41667H13.6875V7.66667H12.9375ZM12.9375 5.75H13.6875V5H12.9375V5.75ZM7.17637 5.75H6.42637V6.5H7.17637V5.75ZM5.73887 0.75H7.17637V-0.75H5.73887V0.75ZM6.48887 5.75V0H4.98887V5.75H6.48887ZM0 6.5H5.73887V5H0V6.5ZM0.75 7.66667V5.75H-0.75V7.66667H0.75ZM5.73887 6.91667H0V8.41667H5.73887V6.91667ZM6.48887 13.4167V7.66667H4.98887V13.4167H6.48887ZM7.17637 12.6667H5.73887V14.1667H7.17637V12.6667ZM6.42637 7.66667V13.4167H7.92637V7.66667H6.42637ZM12.9375 6.91667H7.17637V8.41667H12.9375V6.91667ZM12.1875 5.75V7.66667H13.6875V5.75H12.1875ZM7.17637 6.5H12.9375V5H7.17637V6.5ZM6.42637 0V5.75H7.92637V0H6.42637Z",
    fill: "#F7FCFF",
    mask: "url(#path-10-outside-1_2441_3821)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 9.5835H21.3147V17.5696C21.3147 17.5696 20.7327 21.0835 17.8448 21.0835C14.9569 21.0835 14.375 17.5696 14.375 17.5696V9.5835Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2441_3821",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 8,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 9.5835H21.3147V17.5696C21.3147 17.5696 20.7327 21.0835 17.8448 21.0835C14.9569 21.0835 14.375 17.5696 14.375 17.5696V9.5835Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2441_3821)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.375,
    y: 9.5835,
    width: 6.93966,
    height: 2.875,
    fill: "#C3352C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3491,
    y: 12.1392,
    width: 0.991379,
    height: 8.94444,
    fill: "#C3352C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 15.6528H21.3147V16.9306H14.375V15.6528Z",
    fill: "#C3352C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.201 19.8734C16.6183 20.6599 16.9584 20.9669 17.1987 20.5034C17.3676 20.1777 17.3851 19.8519 17.1444 19.7882C17.0048 19.5516 16.9063 19.3671 16.85 19.2385L16.8581 19.2283C16.9256 19.1408 16.9281 19.0241 16.9148 18.9806C16.9097 18.9211 16.9432 18.8402 17.16 18.6192C17.3565 18.4189 17.4436 18.2304 17.3149 18.0228C17.2472 17.9137 17.1864 17.8918 16.9946 17.8523L16.9356 17.8401C16.8788 17.8279 16.8376 17.8159 16.8116 17.8054L16.6782 17.4646C16.3996 17.4533 16.1819 17.5188 15.9438 17.6528C15.8412 17.7106 15.7721 17.7498 15.726 17.776L15.726 17.776L15.726 17.776L15.7259 17.776C15.6563 17.8155 15.6391 17.8253 15.6383 17.8241C15.638 17.8237 15.6395 17.8221 15.6415 17.82C15.647 17.8142 15.6563 17.8044 15.6429 17.8044C15.5927 17.8044 15.5383 17.7969 15.3874 17.7713L15.3578 17.7664C14.924 17.6937 14.8153 17.696 14.745 17.9652C14.6381 18.3749 15.2713 19.1259 15.6075 19.2161C15.7758 19.2613 15.9774 19.4762 16.201 19.8734ZM16.6727 19.3095C16.7135 19.3095 16.745 19.3072 16.7727 19.2972L16.7811 19.2727C16.7585 19.2931 16.7246 19.3095 16.6727 19.3095ZM15.0896 18.1782C15.0807 18.1643 15.0783 18.1464 15.0844 18.1228C15.0832 18.1276 15.0872 18.1381 15.0957 18.1531C15.104 18.1678 15.1166 18.1867 15.1325 18.2089C15.1132 18.2015 15.0983 18.1918 15.0896 18.1782ZM15.6784 18.7463C15.5579 18.714 15.2514 18.3741 15.1325 18.2089C15.1637 18.2208 15.2062 18.2266 15.2519 18.2328C15.2719 18.2355 15.2925 18.2383 15.313 18.2418L15.3421 18.2467C15.5116 18.2754 15.5708 18.2836 15.6429 18.2836C15.6845 18.2836 15.6759 18.3027 15.6707 18.3143C15.669 18.3181 15.6676 18.3212 15.6686 18.3224C15.6721 18.3269 15.7065 18.3074 15.8674 18.2163C15.923 18.1849 15.9938 18.1448 16.0836 18.0942C16.2108 18.0226 16.327 17.9762 16.4545 17.9553C16.4686 18.0356 16.5036 18.1081 16.5607 18.1672C16.6372 18.2463 16.7237 18.2796 16.8723 18.3118C16.6875 18.5146 16.5947 18.6842 16.5655 18.8496C16.3992 18.9197 16.4144 19.1695 16.5141 19.4192C16.5837 19.5932 16.715 19.8398 16.9105 20.1661L17.0509 20.2561C17.0095 20.2561 16.9863 20.2308 16.9688 20.2116C16.9466 20.1873 16.9333 20.1727 16.9031 20.2309C16.9011 20.2348 16.7703 20.1168 16.4914 19.5912C16.2168 19.1034 15.9505 18.8194 15.6784 18.7463ZM16.5548 19.0335C16.5573 19.0307 16.5571 19.0269 16.5568 19.0232L16.5568 19.0231L16.5548 19.0335ZM16.6697 18.8303L16.659 18.8305L16.664 18.831C16.6659 18.8306 16.6678 18.8304 16.6697 18.8303ZM16.6727 18.8303C16.6717 18.8303 16.6707 18.8303 16.6697 18.8303L16.6727 18.8303Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5645 15.4391C15.5645 15.4391 15.2216 14.8065 15.2216 14.5811",
    stroke: "#964C36",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3515 14.8953C15.3515 14.8953 14.9131 14.6457 14.9131 14.8953",
    stroke: "#2A8E51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3444 14.6324C15.3444 14.6324 15.036 14.1094 14.8042 14.1094C14.5723 14.1094 14.5779 14.3709 14.5779 14.3709",
    stroke: "#2A8E51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1685 14.1085C15.1685 14.1085 15.0309 13.2529 14.8105 13.2529C14.5901 13.2529 14.5901 13.6807 14.5901 13.6807",
    stroke: "#2A8E51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2242 14.1068C15.2242 14.1068 15.1628 13.3735 15.4466 13.3735",
    stroke: "#2A8E51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 15.3152C16.0001 15.3152 15.8401 14.5644 15.8979 14.3525",
    stroke: "#964C36",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9395 14.7074C15.9395 14.7074 15.5916 14.2728 15.5275 14.5074",
    stroke: "#2A8E51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 14.4574C16.0001 14.4574 15.8445 13.8252 15.6266 13.7195C15.4087 13.6137 15.3469 13.862 15.3469 13.862",
    stroke: "#2A8E51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9692 13.8846C15.9692 13.8846 16.0593 13.0179 15.8522 12.9174C15.6451 12.8169 15.5354 13.2189 15.5354 13.2189",
    stroke: "#2A8E51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0219 13.9083C16.0219 13.9083 16.1523 13.1913 16.4189 13.3207",
    stroke: "#2A8E51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.353 15.5829C16.353 15.5829 16.5804 14.8638 16.5424 14.644",
    stroke: "#964C36",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4687 14.989C16.4687 14.989 16.8538 14.6142 16.8959 14.8575",
    stroke: "#2A8E51",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4314 14.7313C16.4314 14.7313 16.6437 14.1292 16.8696 14.0596C17.0955 13.9901 17.1342 14.2466 17.1342 14.2466",
    stroke: "#2A8E51",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5145 14.1678C16.5145 14.1678 16.5042 13.2928 16.719 13.2267C16.9337 13.1606 17.0059 13.5775 17.0059 13.5775",
    stroke: "#2A8E51",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46 14.183C16.46 14.183 16.3961 13.4502 16.1196 13.5353",
    stroke: "#2A8E51",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1892 15.1437C19.1892 15.1437 19.3631 14.0767 19.8581 14.0767C20.3531 14.0767 20.5745 15.2041 20.5745 15.2041",
    stroke: "#2A8E51",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7804 14.4152C18.7804 14.4152 19.0469 13.7849 19.9266 13.8364C20.8062 13.888 20.9665 14.4152 20.9665 14.4152",
    stroke: "#2A8E51",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6027 13.6138C18.6027 13.6138 19.0859 12.8158 19.7631 13.4922L19.9925 13.6138C19.9925 13.6138 20.2225 12.7094 21.3339 13.6138",
    stroke: "#2A8E51",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.937 15.3691C19.937 15.3691 19.9724 14.3732 20.0908 14.0996",
    stroke: "#964C36",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9147 17.5509C20.9147 17.5509 20.4704 17.2723 20.3375 17.5509C20.2046 17.8295 18.6033 20.3893 18.6033 20.3893",
    stroke: "#964C36",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3806 17.8207L20.3731 18.7457C20.3731 18.7457 20.8298 18.3112 20.6015 18.0659C20.3731 17.8207 19.7508 17.3882 19.7508 17.3882L19.3806 17.8207Z",
    fill: "#FFF203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3463 17.8682C19.3463 17.8682 19.1164 18.1891 19.1164 18.4344C19.1164 18.6797 18.9025 19.3372 18.9025 19.3372C18.9025 19.3372 19.5008 19.8283 19.625 19.5155C19.7492 19.2027 20.5561 19.3899 20.4138 18.9122C20.2715 18.4344 19.3463 17.8682 19.3463 17.8682Z",
    fill: "#00A651"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1342 10.7167C15.1342 10.7167 15.6641 10.3541 15.9265 10.7167C16.1888 11.0793 16.4037 10.6867 16.4037 10.468C16.4037 10.2492 16.8202 9.49841 16.8202 10.1076C16.8202 10.7167 16.6906 11.0606 17.0567 11.0606C17.4228 11.0606 19.0714 10.2192 19.4668 10.468C19.8621 10.7167 20.1646 10.6548 20.0641 10.2979C19.9636 9.941 19.7054 9.71792 19.208 9.91274C18.7107 10.1076 18.8281 10.2979 18.3982 10.2979C17.9684 10.2979 17.49 10.1076 17.49 10.1076C17.49 10.1076 17.6244 9.78748 18.1151 10.0152C18.6058 10.2428 19.2827 9.73319 19.4668 9.73319C19.6509 9.73319 20.1575 9.71792 20.2077 9.91274C20.258 10.1076 20.5639 10.2863 20.3307 10.468C20.0975 10.6496 19.713 10.7633 19.9776 10.996C20.2421 11.2287 20.8505 11.1839 20.8798 11.4259C20.9091 11.668 21.1975 12.0294 21.0817 12.0294C20.966 12.0294 20.7569 12.3703 20.5621 12.2665C20.3674 12.1627 20.3445 12.0716 20.5312 11.9875C20.718 11.9034 20.7162 11.5498 20.5621 11.5498C20.4081 11.5498 20.4833 11.6737 20.1326 11.5498C19.7819 11.4259 19.3178 11.2882 19.3457 11.5498C19.3736 11.8114 19.6019 12.213 19.1806 12.2665C18.7594 12.32 18.5622 12.5349 18.4802 12.3619C18.3982 12.1888 18.1051 11.9583 18.3356 11.8843C18.566 11.8104 18.7863 12.1356 18.8693 12.0825C18.9523 12.0294 19.1404 11.9999 18.9828 11.7748C18.8253 11.5498 18.5655 11.4173 18.8063 11.2489C19.0472 11.0805 18.8571 11.077 18.3982 11.4259C17.9393 11.7748 17.6841 12.0713 17.2812 12.0294C16.8784 11.9875 16.7275 12.0441 16.598 11.9875C16.4685 11.9309 15.8379 12.6124 15.6563 12.4395C15.4747 12.2665 14.8884 12.2002 14.9939 11.9875C15.0995 11.7748 15.2412 11.6653 15.399 11.7748C15.5568 11.8843 15.7136 11.9938 15.82 11.8843C15.9265 11.7748 16.2338 11.3991 16.1565 11.324C16.0792 11.2489 16.154 10.996 15.7163 10.996C15.2785 10.996 15.1247 11.2779 15.0208 11.1003C14.9169 10.9227 15.1342 10.7167 15.1342 10.7167Z",
    fill: "#FFD100"
  }))))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2441_3821)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2441_3821",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFjd);
export default __webpack_public_path__ + "static/media/FJD.b385ac40d22510e5b48f0b59f79c2b29.svg";
export { ForwardRef as ReactComponent };